import { Box, Container, Grid, Pagination, Tooltip } from "@mui/material";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Layout from "../Layout";
import Loading from "../Loading";
import SearchInput from "../SearchInput";
import Title from "../Title";
import { pageCounter, paginate } from "../../utils/paginate";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../AlertDialog";
import { useAlert } from "../../context/AlertContext";
import EmptyMessage from "../EmptyMessage";
import { useContent } from "../../content/useContent";

const classes = {
  center: {
    pt: 10,
    pb: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
  },
};

type IProps = {
  title: string;
  multiTitle: string;
  selectRef?: string;
  pageLoading: boolean;
  searchValue?: string;
  handleSearch?: any;
  rowsPerPage: number;
  page: number;
  rows: any[];
  handleChangePage: any;
  Row: any;
  addPath?: any;
  selected: any;
  openDeleteDialog: boolean;
  setOpenDeleteDialog: any;
  handleDelete: any;
  deleteLoading: boolean;
};

const ViewList: React.FC<IProps> = ({
  title,
  multiTitle,
  selectRef,
  pageLoading,
  searchValue,
  handleSearch,
  rowsPerPage,
  page,
  rows,
  handleChangePage,
  Row,
  addPath,
  selected,
  openDeleteDialog,
  setOpenDeleteDialog,
  handleDelete,
  deleteLoading,
}) => {
  const navigate = useNavigate();
  const { msg, error } = useAlert();
  const { general } = useContent();

  const dialogTitle = selectRef
    ? `${general.sureDelete} (${selected && selected[selectRef]})`
    : `${general.sureDelete}`;

  if (error && msg) {
    return (
      <Layout>
        <Container sx={classes.center}>
          <Title title={multiTitle} />
          <EmptyMessage text={msg} />
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container sx={classes.center}>
        <Title title={multiTitle} />

        {pageLoading && <Loading />}

        {!pageLoading && handleSearch && searchValue && (
          <SearchInput
            fullWidth
            label={`${general.search} ${multiTitle}`}
            searchValue={searchValue}
            handleSearch={handleSearch}
          />
        )}

        {!pageLoading && !rows.length && (
          <Box sx={{ height: "59vh" }}>
            <EmptyMessage
              text={`${general.noFound} ${multiTitle} ${general.wereFound}.`}
            />
          </Box>
        )}

        {!pageLoading && rows.length > 0 && (
          <Box sx={{ mt: 1, minHeight: "55vh", width: "100%" }}>
            <Grid container spacing={2}>
              {paginate(rowsPerPage, page - 1, rows).map(
                (row: any, index: any) => (
                  <Grid item xs={12} lg={6} key={index}>
                    <Row row={row} />
                  </Grid>
                )
              )}
            </Grid>
          </Box>
        )}

        {!pageLoading && rows.length > rowsPerPage && (
          <Pagination
            sx={{ mt: 2 }}
            count={pageCounter(rowsPerPage, rows)}
            page={page}
            onChange={handleChangePage}
          />
        )}
      </Container>
      {addPath && (
        <Tooltip
          onClick={() => navigate(addPath)}
          title={`${general.add} ${title}`}
          sx={{ position: "fixed", right: 20, bottom: 20 }}
        >
          <Fab color="primary" aria-label="add">
            <AddIcon />
          </Fab>
        </Tooltip>
      )}

      <AlertDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        onAgree={handleDelete}
        loading={deleteLoading}
        agreeText={general.delete}
        disagreeText={general.cancel}
        title={dialogTitle}
      />
    </Layout>
  );
};

export default ViewList;
